__turbopack_context__.v({
  "burger-menu-button": "navigation-module-scss-module__hlzCuW__burger-menu-button",
  "container": "navigation-module-scss-module__hlzCuW__container",
  "image": "navigation-module-scss-module__hlzCuW__image",
  "nav": "navigation-module-scss-module__hlzCuW__nav",
  "nav-active": "navigation-module-scss-module__hlzCuW__nav-active",
  "nav-close-button": "navigation-module-scss-module__hlzCuW__nav-close-button",
  "nav-group-list-item": "navigation-module-scss-module__hlzCuW__nav-group-list-item",
  "nav-group-list-item-active": "navigation-module-scss-module__hlzCuW__nav-group-list-item-active",
  "nav-group-list-link": "navigation-module-scss-module__hlzCuW__nav-group-list-link",
  "nav-groups-list": "navigation-module-scss-module__hlzCuW__nav-groups-list",
  "nav-groups-list-columns-1": "navigation-module-scss-module__hlzCuW__nav-groups-list-columns-1",
  "nav-groups-list-columns-2": "navigation-module-scss-module__hlzCuW__nav-groups-list-columns-2",
  "nav-groups-list-item": "navigation-module-scss-module__hlzCuW__nav-groups-list-item",
  "nav-groups-list-title": "navigation-module-scss-module__hlzCuW__nav-groups-list-title",
  "nav-groups-list-title-additional-items": "navigation-module-scss-module__hlzCuW__nav-groups-list-title-additional-items",
  "nav-hidden": "navigation-module-scss-module__hlzCuW__nav-hidden",
  "nav-level-0": "navigation-module-scss-module__hlzCuW__nav-level-0",
  "nav-level-0-active": "navigation-module-scss-module__hlzCuW__nav-level-0-active",
  "nav-level-0-button": "navigation-module-scss-module__hlzCuW__nav-level-0-button",
  "nav-level-0-list": "navigation-module-scss-module__hlzCuW__nav-level-0-list",
  "nav-level-0-list-item": "navigation-module-scss-module__hlzCuW__nav-level-0-list-item",
  "nav-level-0-list-item-active": "navigation-module-scss-module__hlzCuW__nav-level-0-list-item-active",
  "nav-level-0-meta-button": "navigation-module-scss-module__hlzCuW__nav-level-0-meta-button",
  "nav-level-1": "navigation-module-scss-module__hlzCuW__nav-level-1",
  "nav-level-1-active": "navigation-module-scss-module__hlzCuW__nav-level-1-active",
  "nav-level-1-back-button": "navigation-module-scss-module__hlzCuW__nav-level-1-back-button",
  "nav-level-1-header": "navigation-module-scss-module__hlzCuW__nav-level-1-header",
  "nav-level-1-title": "navigation-module-scss-module__hlzCuW__nav-level-1-title",
  "placeholder": "navigation-module-scss-module__hlzCuW__placeholder",
  "scroll-wrapper": "navigation-module-scss-module__hlzCuW__scroll-wrapper",
  "teaser-list": "navigation-module-scss-module__hlzCuW__teaser-list",
  "teaser-list-columns-1": "navigation-module-scss-module__hlzCuW__teaser-list-columns-1",
  "teaser-list-columns-2": "navigation-module-scss-module__hlzCuW__teaser-list-columns-2",
  "teaser-list-item": "navigation-module-scss-module__hlzCuW__teaser-list-item",
  "teaser-list-item-image": "navigation-module-scss-module__hlzCuW__teaser-list-item-image",
});
